import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import RootRef from '@material-ui/core/RootRef';

const styles = () => ({
  root: {
    maxWidth: 'none',
    padding: '8px 11px',
  },
});

const AutosuggestFieldSuggestion = ({ className, rootRef, children, classes, ...otherProps }) => {
  const menuItem = (
    <MenuItem
      className={classNames(classes.root, className)}
      component="a"
      {...otherProps}
    >
      {children}
    </MenuItem>
  );
  if (rootRef) {
    return (
      <RootRef
        rootRef={rootRef}
      >
        {menuItem}
      </RootRef>
    );
  }
  return menuItem;
};

AutosuggestFieldSuggestion.propTypes = {
  className: PropTypes.string,
  rootRef: PropTypes.func,
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

AutosuggestFieldSuggestion.defaultProps = {
  rootRef: null,
  className: '',
};

export default withStyles(styles)(AutosuggestFieldSuggestion);



// WEBPACK FOOTER //
// ./src/components/fields/AutosuggestField/AutosuggestFieldSuggestion.js